import React, { useEffect, useRef } from 'react';
import { useAccordionContext } from '@ver-uds/uswds-react';
import { useCollapsableCardContext } from './collapsable-card-context';

export interface CollapsableContentProps {
  children: React.ReactNode;
  id: string;
}

export default function CollapsableContent({ children, id }: CollapsableContentProps) {
  const { isOpen } = useAccordionContext();
  const expanded = isOpen(id);
  const { isTooLong, initializeCollapsable, collapsedMaxHeight } = useCollapsableCardContext();
  const isContentTooLong = isTooLong(id);

  const collapsedMaxHeightStyle = {
    overflow: 'hidden',
    maxHeight: `${collapsedMaxHeight}px`,
  };
  const contentRef = useRef(null);

  useEffect(() => {
    initializeCollapsable(id, contentRef);
  }, [initializeCollapsable, id]);

  return (
    <div
      id={id}
      ref={contentRef}
      className="margin-top-1"
      style={!expanded && isContentTooLong ? collapsedMaxHeightStyle : {}}
    >
      {children}
    </div>
  );
}
